__webpack_require__.p = "/solarkraft-erkunden/";